<div class="header">

  <nav class="navbar navbar-expand-lg navbar-light bg-light sticky-top">
    <div class="container-fluid">
      <a class="navbar-brand" routerLink="/home"><img src="assets/LOGO-ADIAL-cmjn.png" height="80px" width="80px" alt="" style="margin-left: 20px;"></a>

      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Menu">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav" id="test">

          
            <app-search-bar *ngIf="logged && !restricted"></app-search-bar> 

          
          <!-- Available Menu Items are stored in an array -->
          <ng-container *ngIf="logged">
              <li class="nav-item" routerLinkActive="active"  *ngFor="let menuItem of menuItems">
                <a routerLink="{{menuItem.menuLink}}" routerLinkActive="active" data-toggle="collapse"
                  data-target="#navbarSupportedContent.show" class="material-icons nav-link" title="{{menuItem.menuText | translate}}">
                  {{menuItem.menuIcon}}
                </a>
                <span translate>{{menuItem.menuText}}</span>
              </li>
        </ng-container>
        
        <!-- Connexion Menu item is always visible. Could probably chage to 'logout' when user has logged-in-->
        <li class="nav-item" routerLinkActive="active" >
          <a routerLink="/login" routerLinkActive="active" data-toggle="collapse"
            data-target="#navbarSupportedContent.show" class="material-icons nav-link" title="Login" (click)="onLogOut()">login</a>
          <ng-container *ngIf="!logged">
            <span translate>menu.login</span>
          </ng-container>
          <ng-container *ngIf="logged">
              <span  translate>Déconnexion</span>
          </ng-container>
        </li>
      
          <!-- Hidden for now doesn't seem used anymore @BLY 20/10/21
             TODO :: add them in array, not here !! 
          
        Issue #6 <li class="nav-item">
            <a routerLink="/companies-list" routerLinkActive="active" data-toggle="collapse"
              data-target="#navbarSupportedContent.show" class="material-icons nav-link" title="Sociétés">business</a>
            <span>Sociétés</span>
          </li>
          <li class="nav-item">
            <a routerLink="/people-list" routerLinkActive="active" data-toggle="collapse"
              data-target="#navbarSupportedContent.show" class="material-icons nav-link"
              title="Personnes">perm_identity</a>
            <span>Personnes</span>
          </li> <li class="nav-item" routerLinkActive="active">
            <a routerLink="/stock-manager" routerLinkActive="active" data-toggle="collapse"
              data-target="#navbarSupportedContent.show" class="material-icons nav-link"
              title="Gestion du stock">dashboard</a>
            <span>Stocks</span>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a routerLink="/tools" routerLinkActive="active" data-toggle="collapse"
              data-target="#navbarSupportedContent.show" class="material-icons nav-link" title="Outils">construction</a>
            <span>Outils</span>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a routerLink="/wiki" routerLinkActive="active" data-toggle="collapse"
              data-target="#navbarSupportedContent.show" class="material-icons nav-link" title="Wiki">emoji_objects</a>
            <span>Wiki</span>
          </li> 
          <li class="nav-item">
            <a routerLink="/messages-list" routerLinkActive="active" data-toggle="collapse"
              data-target="#navbarSupportedContent.show" class="material-icons nav-link" title="Messages">mail</a>
            <span>Messages</span>
          </li>
        -->
        </ul>
        <ng-container *ngIf="logged">
          <p style="margin-left: 100px; margin-top: 20px;">{{ username }} </p>
        </ng-container>
      </div>
    </div>
  </nav>
 
</div>